import cx from 'classnames';
import createComponent, { type ElementWithProps } from '../createComponent';

const primaryButtonClasses = `
  mc|text-text-primary
  active:mc|text-text-primary-active
  disabled:mc|text-text-disabled
  hover:mc|text-text-primary-hover
`;

const destructiveButtonClasses = `
  mc|text-text-critical
  active:mc|text-text-critical-active
  disabled:mc|text-text-disabled
  hover:mc|text-text-critical-hover
`;

const textButtonSizes = {
  lg: '-:mc|t-label-lg',
  md: '-:mc|t-label-md',
  sm: '-:mc|t-label-sm',
  xs: '-:mc|t-label-sm'
};

export type TextButtonProps = ElementWithProps<
  {
    size?: 'lg' | 'md' | 'sm' | 'xs';
    underline?: boolean;
  },
  HTMLButtonElement
>;

export const BaseTextButton = createComponent<TextButtonProps>(
  'button',
  ({ size = 'md', underline = true }) => ({
    className: cx(
      textButtonSizes[size],
      'mc|border-0 mc|px-0 mc|bg-transparent',
      {
        'mc|underline mc|underline-offset-[6px]': underline
      }
    )
  })
);

export const PrimaryTextButton = createComponent<TextButtonProps>(
  BaseTextButton,
  { className: primaryButtonClasses }
);

export const DestructiveTextButton = createComponent<TextButtonProps>(
  BaseTextButton,
  { className: destructiveButtonClasses }
);
